export const whiteList = [
  '/user/organize/getProjectsByCid'
]

export function filterWhite (url) {
  let res = false
  if (whiteList.find(item => item === url)) {
    res = true
  }
  return res
}
